import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ConsultaCortePecasFornecedor } from "../funcionalidades/bancoGet";
import GlobalVar from "../subComponents/GlobalVar";
import TopMenu from '../TopMenu'
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const exportarCorteEstiloPlanilha = (dados) => {
    if (!dados || dados.length === 0) {
        alert("Nenhum dado para exportar!");
        return;
    }

    const mapa = {};
    const tamanhosSet = new Set();

    // 🔹 Primeiro: agrupar e somar
    dados.forEach(item => {

        const chave = `${item.item}||${item.cor}`;

        if (!mapa[chave]) {
            mapa[chave] = {
                MODELO: item.item,
                COR: item.cor.replaceAll('ORIGINAL', "PRETO"),
                tamanhos: {}
            };
        }

        let tamanhosArray = [];

        if (typeof item.tamanhos === "string") {
            tamanhosArray = item.tamanhos.split(' #### ').map(t => {
                const [tam, qtde] = t.split(' - QTDE ');
                return {
                    tamanho: tam.trim(),
                    quantidade: Number(qtde)
                };
            });
        } else {
            tamanhosArray = item.tamanhos;
        }

        tamanhosArray.forEach(t => {
            tamanhosSet.add(t.tamanho);

            if (!mapa[chave].tamanhos[t.tamanho]) {
                mapa[chave].tamanhos[t.tamanho] = 0;
            }

            mapa[chave].tamanhos[t.tamanho] += t.quantidade;
        });
    });

    // 🔹 ordenar tamanhos (importante!)
    const ordem = ["PP","P","M","G","GG","EXG"];
    const tamanhos = Array.from(tamanhosSet).sort((a, b) => {
        return ordem.indexOf(a) - ordem.indexOf(b);
    });

    // 🔹 montar linhas finais
    const linhas = Object.values(mapa).map((item, index) => {
        const linha = {
            "#": index + 1,
            "MODELO": item.MODELO,
            "COR": item.COR
        };

        tamanhos.forEach(t => {
            linha[t] = item.tamanhos[t] || "";
        });

        return linha;
    });

    const ws = XLSX.utils.json_to_sheet(linhas);

    // largura das colunas (fica bonito igual sua imagem)
    ws["!cols"] = [
        { wch: 5 },
        { wch: 35 },
        { wch: 15 },
        ...tamanhos.map(() => ({ wch: 8 }))
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Corte");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });

    saveAs(blob, "corte_agrupado.xlsx");
};


function getFimSemana() {
    const hoje = new Date();

    // 0 = domingo, 6 = sábado
    const diaSemana = hoje.getDay();

    // dias até sábado
    const diasAteSabado = 6 - diaSemana;

    const fimSemana = new Date(hoje);
    fimSemana.setDate(hoje.getDate() + diasAteSabado);

    // formatar YYYY-MM-DD
    const ano = fimSemana.getFullYear();
    const mes = String(fimSemana.getMonth() + 1).padStart(2, '0');
    const dia = String(fimSemana.getDate()).padStart(2, '0');

    return `${ano}-${mes}-${dia}`;
}


function getFimSemanaAnterior() {
    const hoje = new Date();

    // 0 = domingo, 6 = sábado
    const diaSemana = hoje.getDay();

    const fimSemanaAnterior = new Date(hoje);

    // volta até o domingo passado
    // se hoje for domingo, pega o domingo da semana anterior
    const diasParaVoltar = diaSemana === 0 ? 7 : diaSemana;

    fimSemanaAnterior.setDate(hoje.getDate() - diasParaVoltar);

    // formatar YYYY-MM-DD
    const ano = fimSemanaAnterior.getFullYear();
    const mes = String(fimSemanaAnterior.getMonth() + 1).padStart(2, '0');
    const dia = String(fimSemanaAnterior.getDate()).padStart(2, '0');

    return `${ano}-${mes}-${dia}`;
}

function CardCorte({item}){

    const urlImage = `https://apifornecedores.babita.com.br/images/${item.sku}.jpg`
    const [bg, setBg] = useState('#FFF');
        
    useEffect(() => {
      console.log("TESTE IMAGE")
      console.log(urlImage)
      const img = new Image();
      img.src = urlImage;
  
      img.onload = () => {
        setBg(`url('${urlImage}')`);
      };
  
      img.onerror = () => {
        setBg(`url('https://apifornecedores.babita.com.br/images/publicImages/ImagemNaoEncontrada.jpg')`);
      };
    }, [urlImage]);
    console.log(item)

    return <>
        <div className="cardProdCorte">
            {/* <div className="leftFoto">
                <div className="fotoProd" style={{background: `${bg} no-repeat center/contain`}}></div>
            </div> */}
            <div className="rightInfo">
                <div className="prodFornecedor">{item.fabricante}</div>
                <div className="prodItem">{item.item}</div>
                <div className="prodCor">COR: {item.cor}</div>
                <div className="tamSpacer"></div>
                <div className="tamTitle"></div>
                <div className="tamContainer">
                    {item.tamanhos.map((val)=>{
                        return <div className="tamCard"><span>{val.tamanho}</span>{ " • "+ val.quantidade + " UNI"}</div>
                    })}
                </div>

            </div>
        </div>
    </>
}

const CorteDePecasFornecedor = ({ativaResp, showStyle}) => {

    // const navigate = useNavigate();
    

    useEffect(()=>{
        if(!showStyle) return;
        import('../../assets/css/auxiliar/scrolbar.css')
        import('../../assets/css/estiloPaginas/consultarCorteDePecasFornecedor.css')
    },[])



    const [produtosCorte, setProdutosCorte] = useState([])   
    const [atualizaConsulta, setatualizaConsulta] = useState(false)

    const [dataInicial, setDataInicial] = useState(getFimSemanaAnterior()) 
    const [dataFinal, setDataFinal] = useState(getFimSemana()) 

    const [usuario, setUsuario] = useState(GlobalVar.getSessionStorage('usuario'));
     const cargo = () => usuario?.usu_tipo == 4 ? 'EXPEDICAO' : usuario.fornInfo?.for_cod ? 'FORNECEDOR' : 'VENDEDORA'


    useEffect(()=>{
        if(!usuario) return;
            setProdutosCorte([])
            ConsultaCortePecasFornecedor({fornecedor: usuario.fornInfo?.for_cod, dataInicial: dataInicial, dataFinal: dataFinal})
                .then((resp)=>{
                    if(resp.Error){
                        
                    }else{
                        const respTratada = resp.map(item => {
                            const tamanhosArray = item.tamanhos.split(' #### ').map(t => {
                                const [tam, qtde] = t.split(' - QTDE ');
                                
                                return {
                                    tamanho: tam.trim(),
                                    quantidade: Number(qtde)
                                };
                            });
                    
                            return {
                                ...item,
                                tamanhos: tamanhosArray
                            };
                        });

                        setProdutosCorte(respTratada)
                    }
                })
        
    },[usuario, atualizaConsulta])


    if (!usuario) {
        return <div>Carregando...</div>;
      }
    return <>
    <TopMenu ativaResp={ativaResp} showStyle={true}>
    </TopMenu>
            <div className="containerPrincipal consultarCorteFornecedor" style={{minHeight: "90vh", /*maxHeight: windowHeight*0.80,*/ display: 'flex',
    flexDirection: 'column', /*overflowY: "hidden"*/}}>
                <div className="container-filtro">
                    <div className="grupo-input">
                        <label>Data Inicial</label>
                        <input
                        type="date"
                        value={dataInicial}
                        onChange={(e) => setDataInicial(e.target.value)}
                        />
                    </div>

                    <div className="grupo-input">
                        <label>Data Final</label>
                        <input
                        type="date"
                        value={dataFinal}
                        onChange={(e) => setDataFinal(e.target.value)}
                        />
                    </div>

                    <button className="btn-buscar" onClick={()=>setatualizaConsulta(!atualizaConsulta)}>
                        Buscar
                    </button>

                    {produtosCorte ? <button 
                        className="btn-exportar"
                        onClick={() => exportarCorteEstiloPlanilha(produtosCorte)}
                    >
                        EXPORTAR
                    </button> : <></>}
                    </div>

                <div className="corteContainer">
                    {produtosCorte ? produtosCorte.map((item)=>{
                        return <CardCorte item={item} />
                    }) : <></>}
                </div>

        </div>
           </>
}

export default CorteDePecasFornecedor;
